import {list} from "@mc/mc-legacy";
import NotifikaceApi from "../api/gen/cgo/NotifikaceApi";

export const NOTIFIKACE_LIST_AREA = "notifikaceList";
export const NOTIFIKACE_HELP_LIST_AREA = "notifikaceHelpList";

/**
 * Načtení seznamu notifikací.
 * @returns {Function}
 */
export function fetchNotifikaceIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(NOTIFIKACE_LIST_AREA, "", (parent, filter) => {
            return NotifikaceApi.getNotifikaceObj(filter.vcetneNeaktivnich ? null : false);
        }));
    }
}

/**
 * Filtrování notifikací.
 * @param filter filtr
 * @returns {Function}
 */
export function filterNotifikace(filter) {
    return (dispatch) => {
        dispatch(list.SimpleListActions.filter(NOTIFIKACE_LIST_AREA, filter));
    }
}

/**
 * Zneplatnění seznamu notifikací.
 * @returns {Function}
 */
export function invalidateNotifikace() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(NOTIFIKACE_LIST_AREA));
    }
}

/**
 * Načtení seznamu nápověd pro notifikace.
 * @returns {Function}
 */
export function fetchNotifikaceHelpIfNeeded() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.fetchIfNeeded(NOTIFIKACE_HELP_LIST_AREA, "", () => {
            return NotifikaceApi.getNotifikaceObjHelp();
        }));
    }
}

/**
 * Zneplatnění seznamu nápověd pro notifikace.
 * @returns {Function}
 */
export function invalidateNotifikaceHelp() {
    return (dispatch) => {
        dispatch(list.SimpleListActions.invalidate(NOTIFIKACE_HELP_LIST_AREA));
    }
}
